/**
 * Threshold Colors
 *
 * Color configuration for alert threshold visualization.
 * Uses Polaris CSS variables for consistent theming.
 *
 * Used by:
 * - AlertConfigurationCard (threshold sliders)
 * - ThresholdStep (onboarding threshold configuration)
 */

export interface ThresholdColorConfig {
  /** Light background for the threshold row */
  background: string;
  /** Border color for the threshold row */
  border: string;
  /** Background color for the icon container */
  iconBg: string;
  /** Polaris icon tone */
  iconTone: 'critical' | 'warning' | 'success';
}

export const THRESHOLD_COLORS: Record<'critical' | 'warning' | 'healthy', ThresholdColorConfig> = {
  critical: {
    background: 'rgba(228, 62, 62, 0.06)',
    border: 'var(--p-color-border-critical)',
    iconBg: 'var(--p-color-bg-fill-critical-secondary)',
    iconTone: 'critical',
  },
  warning: {
    background: 'rgba(178, 132, 0, 0.06)',
    border: 'var(--p-color-border-warning)',
    iconBg: 'var(--p-color-bg-fill-warning-secondary)',
    iconTone: 'warning',
  },
  healthy: {
    background: 'rgba(41, 132, 90, 0.06)',
    border: 'var(--p-color-border-success)',
    iconBg: 'var(--p-color-bg-fill-success-secondary)',
    iconTone: 'success',
  },
};

/**
 * Tooltip content for threshold badges
 */
export const THRESHOLD_TOOLTIPS: Record<'critical' | 'warning' | 'healthy', string> = {
  critical: 'Stock levels are critically low. Immediate action recommended.',
  warning: 'Stock is running low. Consider reordering soon.',
  healthy: 'Stock levels are healthy based on current velocity.',
};
